import React from "react";
import Table from "../list/Table";
import { Link } from "react-router-dom";
import { CiBadgeDollar } from "react-icons/ci";
import { useTranslation } from "react-i18next";
import objectPath from "object-path";
import { API_ROOT } from "../defines";
import moment from "moment";
const List = () => {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col ">
      <div className="flex items-center justify-between w-full h-20 py-3 px-8">
        <div className="text-xl font-semibold leading-5 text-black ">
          {t("price.price")}
        </div>
        <Link
          to={`new`}
          className="p-2 border-2 rounded hover:cursor-pointer border-primary"
        >
          <CiBadgeDollar color="#1A2E55" />
        </Link>
      </div>
      <div className="px-4">
        <Table
          url={`/price/table`}
          sort={{ _id: -1 }}
          columns={[
            {
              label: t("price.price"),
              key: `price`,
              sort: true,
              filter: {
                type: "text",
              },
              render: ({ _id, price }) => {
                return (
                  <Link to={`view/${_id}`}>
                    <div class="text-primary underline font-semibold">
                      {`${price
                        ?.toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}¥`}
                    </div>
                  </Link>
                );
              },
            },
            {
              label: t("price.coat"),
              key: `coat`,
              sort: true,
              filter: {
                type: "text",
              },
              render: ({ _id, coat }) => {
                return (
                  <div class="text-primary font-semibold">
                    {`${coat
                      ?.toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}¥`}
                  </div>
                );
              },
            },
            {
              label: t("price.material"),
              key: `material.name`,
              sort: true,
              filter: {
                type: "text",
              },
            },
            {
              label: t("price.size"),
              key: `size.name`,
              sort: true,
              filter: {
                type: "text",
              },
            },
            {
              label: t("createdby"),
              key: `createdby.email`,
              sort: true,
              filter: {
                type: "text",
              },
            },
            {
              label: t("created"),
              // label: `Бүртгэсэн огноо`,
              key: `created`,
              sort: true,
              filter: {
                type: "text",
              },
              render: ({ created }) =>
                moment(created).format("YYYY-MM-DD HH:mm:ss"),
            },
          ]}
        />
      </div>
    </div>
  );
};

export default List;
